module.exports = __webpack_public_path__ + "img/logo_vvf.4e9ff0b4.jpg";